export default "__VITE_ASSET__DOJAa80D__"